<template>
  <div class="modal fade"
       id="modal-create-family"
       tabindex="-1"
       role="dialog"
       data-bs-backdrop="static"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ isEdit ? 'Modifier la Famille' : 'Ajouter une Famille' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>

        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider
                      name="Code"
                      rules="required|min:2|max:5"
                      v-slot="{ errors }"
                      :custom-messages="{
                      min: 'Le code doit contenir au moins 2 caractères.',
                      max: 'Le code doit contenir au plus 5 caractères.'
                    }"
                  >
                    <label class="form-label">Code <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.code"
                        type="text"
                        :disabled="isEdit"
                        @input="payload.code = (payload.code || '').toUpperCase()"
                        class="form-control"
                        placeholder="Ex: FMC"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider name="Label" rules="required" v-slot="{ errors }">
                    <label class="form-label">Nom de la famille <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.label"
                        @input="payload.label = (payload.label || '').toUpperCase()"
                        type="text"
                        class="form-control"
                        placeholder="Ex: Informatique, Mobilier..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-12 mb-0">
                  <ValidationProvider name="Label" rules="required" v-slot="{ errors }">
                    <label class="form-label">Description </label>
                    <textarea class="form-control" v-model="payload.description" placeholder="Description...."
                              id="floatingTextarea2" style="height: 100px"></textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>

              <div class="text-end mt-4">
                <button type="button" class="btn btn-gray me-2" data-bs-dismiss="modal">Annuler</button>
                <button type="submit" class="btn btn-success" :disabled="invalid">
                  <i class="fe fe-check"></i> {{ isEdit ? 'Modifier' : 'Créer' }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { confirmAction, showValidationErrors } from "../../helpers/helpers";
  import {API} from "../../helpers/api-endpoints";

  export default {
    name: "ModalCreateFamily",
    props: {
      family: { type: Object, default: null },
    },
    data() {
      return {
        payload: { code: "", label: "", description: "" },
      };
    },
    computed: {
      isEdit() {
        return !!this.family;
      },
    },
    watch: {
      family: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.payload = {
              code: newVal.code || "",
              label: newVal.label || "",
              description: newVal.description || "",
            };
          } else {
            this.resetForm();
          }
        },
      },
    },
    methods: {
      resetForm() {
        this.payload = { code: "", label: "", description: "" };
        if (this.$refs.observer) this.$refs.observer.reset();
      },

      async submitForm() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const { confirmed } = await confirmAction(this.isEdit ? "edit" : "create");
        if (!confirmed) return;

        this.$loading(true);
        const req = this.isEdit
            ? this.$http.put(API.REGISTRY_FAMILY_ID(this.family.code), this.payload)
            : this.$http.post(API.REGISTRY_FAMILIES, this.payload);

        req
            .then(() => {
              setTimeout(() => {
                swal('Succès', `Famille ${this.isEdit ? 'modifiée' : 'créée'} avec succès.`, 'success');
              }, 200);
              this.$emit('refresh');
              $('#modal-create-family').modal('hide');
              this.resetForm(); // ✅ vider après succès
            })
            .catch((err) => {
              console.error(err);
              setTimeout(() => showValidationErrors(err), 200);
            })
            .finally(() => this.$loading(false));
      },
    },
    mounted() {
      // ✅ réinitialise quand la modale se ferme (croix / Annuler / clic extérieur)
      $('#modal-create-family').on('hidden.bs.modal', () => this.resetForm());
    },
    beforeDestroy() {
      $('#modal-create-family').off('hidden.bs.modal');
    },
  };
</script>
